// main-app/src/micros/actions.js
import { initGlobalState } from 'qiankun'
import store from '@/store'
// 初始化 state
const initState = {
  ...store.getters
}
const actions = initGlobalState(initState)

export default actions
